import { render } from "./SuppliersToolbar.vue?vue&type=template&id=b9adecbc&scoped=true"
import script from "./SuppliersToolbar.vue?vue&type=script&lang=js"
export * from "./SuppliersToolbar.vue?vue&type=script&lang=js"

import "./SuppliersToolbar.vue?vue&type=style&index=0&id=b9adecbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9adecbc"]])

export default __exports__